// https://vuex.vuejs.org/en/state.html

export default {
  authStatus: '',
  user: {},
  userInfo: {},
  tableList: [],
  spinning: false
}
